export const ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT;
export const MAINTENANCE_MODE = import.meta.env.VITE_APP_MAINTENANCE_MODE;
export const MAINTENANCE_TEXT = import.meta.env.VITE_APP_MAINTENANCE_TEXT;
export const SEGMENT_WRITE_KEY = import.meta.env.VITE_APP_SEGMENT_WRITE_KEY;
export const SENTRY_DSN = import.meta.env.VITE_APP_SENTRY_DNS;
export const FAVICON = import.meta.env.VITE_APP_FAVICON;
export const USE_SANDBOX = import.meta.env.VITE_APP_USE_SANDBOX;
export const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;
